class Extranet.Collections.Contacts extends Backbone.Collection

  url: '/v2/getaways/extranet/contacts'
  model: Extranet.Models.Contact